import React, { memo } from "react"
import Img from "gatsby-image"

const ImageWithTextSection = ({ caseStudyData, dataFormImages, classText, title }) => {
    return (
        <div className={`prod-features${classText ? " " + classText : ""}`}>
            {title && (
                <div className="prod-features__header">
                    <h2 className="prod-features__title">{title}</h2>
                </div>
            )}
            <div className="prod-feature-cards">
                {caseStudyData.data.map((d, index) => {
                    const img = dataFormImages[`img${index + 1}`]
                    return (
                        <div key={index} className="prod-feature-card">
                            <div className="prod-feature-card__img-wrap">
                                {img && (
                                    <Img
                                        fluid={img.childImageSharp.fluid}
                                        alt={d.heading}
                                        imgStyle={{ objectFit: "contain" }}
                                    />
                                )}
                            </div>
                            <div className="prod-feature-card__body">
                                <h3 className="prod-feature-card__heading">{d.heading}</h3>
                                <p className="prod-feature-card__desc">{d.description}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default memo(ImageWithTextSection)
